import { useState } from "react";
import CompanyDataListItem from "./CompanyDataListItem";
import { useCachedFirebaseCrud } from "../../../helpers/firebase";
import { IndustryAutocomplete } from "@aclymatepackages/modules";
import { fetchNaicsCodes } from "../../../helpers/utils/apiCalls";

const industryDisplayLabel = (industry) => {
  if (typeof industry === "string") {
    return industry;
  }
  return industry?.naicsTitle || industry?.label || null;
};

const CompanyIndustryRow = ({ industry }) => {
  const { updateAccountData } = useCachedFirebaseCrud();

  const normalizedIndustry =
    typeof industry === "string" ? { label: industry } : industry;
  const [modifyIndustry, setModifyIndustry] = useState(normalizedIndustry);

  const saveModifyIndustry = (newValue) => {
    setModifyIndustry(newValue);
    updateAccountData({ industry: newValue });
  };

  return (
    <CompanyDataListItem
      editingComponent={
        <IndustryAutocomplete
          industry={modifyIndustry}
          setIndustry={saveModifyIndustry}
          fetchNaicsCodes={fetchNaicsCodes}
        />
      }
      saveDisabled={!modifyIndustry}
      onCancel={() => setModifyIndustry(normalizedIndustry)}
      onSave={() => updateAccountData({ industry: modifyIndustry })}
      primaryText={industryDisplayLabel(industry)}
      secondaryText="Company Industry"
    />
  );
};
export default CompanyIndustryRow;
